<template>
  <div class="pricing">
    <div class="filtersContainer">
      <md-toolbar class="md-transparent md-theme-default md-elevation-0 md-toolbar-filters md-sticky">
        <md-list class="md-filters-container mainFilters">
          <div class="d-flex">
            <md-icon class="md-icon-outlined">filter_alt</md-icon>

            <date-range-picker
              :start="filters.travel_from"
              :end="filters.travel_to"
              @change="changeTravelDate"
              :displayList="true"
              :min-days="1"
              :max-days="maxDays"
              :max-months="3"
              :displayFrom="false"
              :displayTo="false"
              displayFromTo
              style="min-width: 230px;"
            >
            </date-range-picker>
          </div>

          <room-type-select ref="roomTypeSelect" multiple v-model="filters.room_type_ids"></room-type-select>

          <md-field>
            <label>Online/Offline</label>
            <md-select v-model="filters.channel_online_types">
              <md-option :value="true">Online</md-option>
              <md-option :value="false">Offline</md-option>
            </md-select>
          </md-field>

          <channel-select multiple v-model="filters.channel_ids" :online="filters.channel_online_types"></channel-select>
          <board-select multiple v-model="filters.board_ids"></board-select>
          <rate-select multiple v-model="filters.rate_ids"></rate-select>
          <compset-select multiple v-model="filters.compset_ids"></compset-select>
        </md-list>
        <md-list class="md-filters-container">
          <md-switch v-model="filters.include_guarantee">Guarantee</md-switch>
          <md-switch v-model="filters.include_tentative">Tentative</md-switch>
          <md-switch v-model="filters.include_orr">ORR</md-switch>
        </md-list>
        <div class="md-toolbar-section-end">
          <md-button class="md-raised md-primary" @click="aplicarFiltro">Aplicar</md-button>
        </div>
      </md-toolbar>
    </div>

    <div v-show="isReady.length < 2" style="position:absolute; right: 50%; margin-top: 30px;">
      <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
    </div>

    <div :class="{ 'md-layout opacity-0': isReady.length < 2 }">
      <div class="md-layout-item occ" v-if="stackedData">
        <div class="visibility-button-container">
          <button class="visibility-button" @click="changeVisibility('pricingHistoryCard', $event)">
            <i class="md-icon md-icon-font">visibility_off</i>
          </button>
        </div>
        <PricingHistoryCard
          v-show="showPricingHistoryCard"
          ref="stackedBars"
          :data="stackedData"
          :options="stackedOptions"
          @wrapper-init="initEvents"
          @offset-updated="updateOffset"
        />
        <div class="visibility-button-container">
          <button class="visibility-button" @click="changeVisibility('occPickUpCard', $event)">
            <i class="md-icon md-icon-font">visibility_off</i>
          </button>
        </div>
        <div v-show="showOccPickUpCard">
          <md-card>
            <md-card-content>
              <md-table id="reference-width" class="x-sync md-scrollbar md-theme-default">
                <md-table-row>
                  <md-table-cell></md-table-cell>
                  <md-table-cell v-for="date in stackedData.labels" :key="date">
                    <small>{{ date }}</small>
                  </md-table-cell>
                </md-table-row>
                <md-table-row v-for="(data, dataIndex) in occupationBriefTableData" :key="'data_' + dataIndex">
                  <md-table-cell class="h6"
                    >{{ data.label }} <span v-if="data.data_offset">({{ data.data_offset }} days)</span></md-table-cell
                  >
                  <template v-for="(value, rowIndex) in data.values">
                    <md-table-cell
                      :key="'cell_occ_' + rowIndex"
                      :class="{
                        'text-success': data.withColors && value > 0,
                        'text-danger': data.withColors && value < 0,
                      }"
                    >
                      {{ value }}
                    </md-table-cell>
                  </template>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
        <div class="visibility-button-container">
          <button class="visibility-button" @click="changeVisibility('adrPickUpCard', $event)">
            <i class="md-icon md-icon-font">visibility_off</i>
          </button>
        </div>
        <div v-show="showAdrPickUpCard">
          <md-card>
            <md-card-content>
              <md-table class="x-sync md-scrollbar md-theme-default">
                <md-table-row>
                  <md-table-cell></md-table-cell>
                  <md-table-cell v-for="date in adrData.labels" :key="date">
                    <small>{{ date }}</small>
                  </md-table-cell>
                </md-table-row>
                <md-table-row v-for="(data, dataIndex) in occupationAdrTableData" :key="'data_' + dataIndex">
                  <md-table-cell class="h6"
                    >{{ data.label }} <span v-if="data.data_offset">({{ data.data_offset }} days)</span></md-table-cell
                  >
                  <template v-for="(value, rowIndex) in data.values">
                    <md-table-cell
                      :key="'cell_occ_' + rowIndex"
                      :class="{
                        'text-success': data.withColors && value > 0,
                        'text-danger': data.withColors && value < 0,
                      }"
                    >
                      {{ value }}
                    </md-table-cell>
                  </template>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <div class="md-layout-item price">
        <div class="visibility-button-container">
          <button class="visibility-button" @click="changeVisibility('pricingInformationCard', $event)">
            <i class="md-icon md-icon-font">visibility_off</i>
          </button>
        </div>

        <div v-show="showPricingInformationCard">
          <md-card v-if="linearData">
            <md-card-content class="chart x-sync md-scrollbar md-theme-default">
              <line-chart
                ref="linesChart"
                scrollable
                :height="200"
                :data="linearData"
                :options="linechartOptions"
                @wrapper-init="initEvents"
              ></line-chart>
            </md-card-content>
          </md-card>
        </div>
        <div class="visibility-button-container">
          <button class="visibility-button" @click="changeVisibility('fusionTable', $event)">
            <i class="md-icon md-icon-font">visibility_off</i>
          </button>
        </div>
        <div v-show="showFusionTable">
          <div class="fixed-cell">
            <md-button @click="setFutureLock" class="md-just-icon"><md-icon class="md-icon-outlined">lock</md-icon></md-button>
            <md-button @click="setFutureUnlock" class="md-just-icon"><md-icon class="md-icon-outlined">lock_open</md-icon></md-button>
            <md-button @click="openAdvancedAllotment" class="md-just-icon"><md-icon class="md-icon-outlined">bed</md-icon></md-button>
            <md-button @click="openAdvancedPricing" class="md-just-icon">
              <i class="md-icon md-icon-font md-theme-default">credit_card</i>
            </md-button>
            <md-button @click="refreshTable" class="md-just-icon">
              <i class="md-icon md-icon-font md-theme-default">autorenew</i>
            </md-button>
          </div>

          <ValidationObserver ref="validator">
            <pricing-table-component
              v-if="!searchPricingAllotment"
              id="pricingTable"
              ref="pricingTable"
              @save="saveRecommendedValues"
              v-model="apiPriceAllotmentResponse"
              :occupancyPerAnticipation="apiOccupancyResponse"
              @allotmentSelected="allotmentSelected"
              @pricingSelected="pricingSelected"
              :class="[futureClass, { 'is-non-dirty': futureClass != null }]"
            ></pricing-table-component>
          </ValidationObserver>

          <md-button class="md-success" @click="fusionSave">Save</md-button>
        </div>
      </div>
    </div>

    <allotment-modal
      v-if="liveModal"
      ref="modal"
      @save="saveAdvanceAllotment"
      @clear="selectionAllotmentCounter = 0"
      :hasSelectedDates="selectionAllotmentCounter > 0"
    />

    <pricing-modal
      v-if="liveModal"
      ref="modalPricing"
      @save="saveAdvancePricing"
      @clear="selectionPricingCounter = 0"
      :hasSelectedDates="selectionPricingCounter > 0"
    />
  </div>
</template>

<script>
/*eslint-disable */

import AllotmentRow from '@/components/Allotment/AllotmentRow'
import { colors } from '@/components/Charts/colors.js'
import DateRangePicker from '@/components/Inputs/DateRangePicker'
import RateSelect from '@/components/Inputs/RateSelect.vue'
import AllotmentModal from '../../../components/Allotment/AllotmentBatchModal.vue'
import PricingHistoryCard from '../../../components/ChartCards/PricingHistoryCard.vue'
import LineChart from '../../../components/Charts/LineChart.vue'
import BoardSelect from '../../../components/Inputs/BoardSelect.vue'
import ChannelSelect from '../../../components/Inputs/ChannelSelect.vue'
import CompsetSelect from '../../../components/Inputs/CompsetSelect.vue'
import RoomTypeSelect from '../../../components/Inputs/RoomTypeSelect.vue'
import PricingModal from '../../../components/Pricing/PricingBatchModal.vue'
import PricingTableComponent from '../../../components/Pricing/PricingTableComponent.vue'
import AllotmentApi from '../../../openapi/src/api/AllotmentApi'
import PricingApi from '../../../openapi/src/api/PricingOccupancyApi'
import RatesApi from '../../../openapi/src/api/RatesApi'
import AdvancedAllotmentActionRequestDTO from '../../../openapi/src/model/AdvancedAllotmentActionRequestDTO'
import AdvancedPricingActionRequestDTO from '../../../openapi/src/model/AdvancedPricingActionRequestDTO'
import SavePriceRequestDTO from '../../../openapi/src/model/SavePriceRequestDTO'
import SimpleAllotmentActionDTO from '../../../openapi/src/model/SimpleAllotmentActionDTO'
import SimpleAllotmentDTO from '../../../openapi/src/model/SimpleAllotmentDTO'
import PricingMixins from './PricingMixins'
import Swal from 'sweetalert2'
import Currency from '@/utils/Currency'

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0
}
function initScrollBlock() {
  if (hasElement('priceTable')) {
    let table = document.getElementsByClassName('priceTable')[0]
    table.addEventListener('scroll', function() {
      if (window.scrollY + document.body.clientHeight < document.body.scrollHeight) {
        window.scrollBy(0, this.scrollTop)
        table.scrollTo(this.scrollLeft, 0)
      }
    })
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollBlock()
    }, 100)
  }
}

const pricingApi = new PricingApi()
const allotmentApi = new AllotmentApi()
let currency

export default {
  components: {
    LineChart,
    PricingHistoryCard,
    RoomTypeSelect,
    CompsetSelect,
    RateSelect,
    BoardSelect,
    ChannelSelect,
    PricingTableComponent,
    DateRangePicker,
    AllotmentRow,
    AllotmentModal,
    PricingModal,
  },
  props: {},
  mixins: [PricingMixins],
  data() {
    return {
      // global data
      maxDays: 10,
      apiPriceAllotmentResponse: null,
      apiOccupancyResponse: null,
      stackedData: null,
      linearData: null,
      isReady: [],
      filters: {
        travel_from: this.moment()
          .toDate()
          .toISOString(),
        travel_to: this.moment()
          .toDate()
          .toISOString(),
        offset: -2,
        channels_online: true,
        channel_online_types: true,
        room_type_ids: [],
        channel_ids: [],
        board_ids: [],
        rate_ids: [],
        compset_ids: [],
        include_guarantee: true,
        include_tentative: false,
        include_orr: false,
      },
      futureClass: null,
      selectionAllotmentCounter: 0,
      selectionPricingCounter: 0,
      liveModal: true,
      // style of each line of the LineChart
      lineStyles: {
        'current': {
          backgroundColor: colors.current,
          borderColor: colors.current,
          fill: false,
        },
        'compset': {
          backgroundColor: colors.compset,
          borderColor: colors.compset,
          fill: false,
        },
        'magic price': {
          backgroundColor: colors.magic_price,
          borderColor: colors.magic_price,
          borderDash: [10, 5],
          fill: false,
        },
      },
      // global LineChart options
      linechartOptions: {
        //events: [],
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0.1,
          },
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        scales: {
          xAxes: [
            {
              display: true,
              ticks: {},
            },
          ],
        },
      },
      showHiddeableRows: false,
      // stacked bar chart data
      stackedOptions: {
        legend: false,
      },
      showPricingHistoryCard: true,
      showOccPickUpCard: true,
      showAdrPickUpCard: true,
      showPricingInformationCard: true,
      showFusionTable: true,
      searchPricingAllotment: false,
    }
  },
  watch: {
    'filters.channel_online_types': function() {
      this.filters.channel_ids = []
    },
    'filters.room_type_ids': {
      handler: function(newVal) {
        if (newVal && newVal.length > 0) {
          this.filters.board_ids = []
        }
      },
    },
    'filters.board_ids': {
      handler: function(newVal) {
        if (newVal && newVal.length > 0) {
          this.filters.room_type_ids = []
        }
      },
    },
  },
  computed: {
    formattedFrom() {
      return this.moment(this.filters.travel_from, 'YYYY-MM-DD').format('YYYY-MM-DD')
    },
    formattedTo() {
      return this.moment(this.filters.travel_to, 'YYYY-MM-DD').format('YYYY-MM-DD')
    },
    adrData() {
      var getBarValues = function(data) {
        var bars = Array(this.apiOccupancyResponse?.label.length)
        data.value.data.forEach((d) => {
          var label = this.apiOccupancyResponse?.label.find((l) => l.key == d.key)
          // eslint-disable-next-line
          bars[label.value.toLowerCase()] = {
            value: d.value,
            order: label.key,
          }
        })
        return Object.assign({}, bars)
      }
      var getDataChartAnticipation = function(n) {
        var data = this.apiOccupancyResponse?.adr_data_chart_per_anticipation
          .find((d) => d.key == n)
          ?.value.dataset.map((d) => {
            return {
              label: this.moment(d.key).format('DD MMM'),
              data_offset: n,
              target: {
                value: d.value.target,
              },
              bars: getBarValues.call(this, d),
            }
          })
        return data
      }
      var data = {
        labels: getDataChartAnticipation.call(this, 0)?.map((d) => d.label),
        datasets: [].concat(getDataChartAnticipation.call(this, 0), getDataChartAnticipation.call(this, this.filters.offset)),
        options: this.apiOccupancyResponse?.label.reduce((accum, current) => {
          accum[current.value.toLowerCase()] = {
            label: current.value,
            order: current.key,
          }
          return accum
        }, {}),
      }
      return data
    },
    // reduced table occupation data
    occupationBriefTableData() {
      var brief = Array(4)
      brief[0] = {
        label: '% Occ',
        data_offset: 0,
        values: this.stackedData.datasets
          .filter((data) => data.data_offset == 0)
          .map((d) => {
            return Number(Object.values(d.bars).reduce((accumulator, bar) => accumulator + bar.value, 0)).toFixed(2)
          }),
      }
      brief[1] = {
        label: '% Occ',
        data_offset: this.filters.offset,
        values: this.stackedData.datasets
          .filter((data) => data.data_offset == this.filters.offset)
          .map((d) => {
            return Number(Object.values(d.bars).reduce((accumulator, bar) => accumulator + bar.value, 0)).toFixed(2)
          }),
      }
      brief[2] = {
        label: 'Pickup',
        withColors: true,
        data_offset: 0,
        values: brief[1].values.map((value, index) => {
          return (brief[0].values[index] - brief[1].values[index]).toFixed(2)
        }),
      }
      brief[3] = {
        label: 'Diff vs Forecast',
        withColors: true,
        data_offset: 0,
        values: this.stackedData.datasets
          .filter((data) => data.data_offset == 0)
          .map((data, index) => (brief[0].values[index] - data.target.value).toFixed(2)),
      }
      return brief
    },
    occupationAdrTableData() {
      var brief = Array(4)
      brief[0] = {
        label: `${this.currency} ADR`,
        data_offset: 0,
        values: this.adrData.datasets
          .filter((data) => data?.data_offset == 0)
          .map((d) => {
            return Number(Object.values(d.bars).reduce((accumulator, bar) => accumulator + bar.value, 0)).toFixed(2)
          }),
      }
      brief[1] = {
        label: `${this.currency} ADR`,
        data_offset: this.filters.offset,
        values: this.adrData.datasets
          .filter((data) => data?.data_offset == this.filters.offset)
          .map((d) => {
            return Number(Object.values(d.bars).reduce((accumulator, bar) => accumulator + bar.value, 0)).toFixed(2)
          }),
      }
      brief[2] = {
        label: 'Pickup',
        withColors: true,
        data_offset: 0,
        values: brief[1].values.map((value, index) => {
          return (brief[0].values[index] - brief[1].values[index]).toFixed(2)
        }),
      }
      brief[3] = {
        label: 'Diff vs Forecast',
        withColors: true,
        data_offset: 0,
        values: this.adrData.datasets
          .filter((data) => data?.data_offset == 0)
          .map((data, index) => (brief[0].values[index] - data.target.value).toFixed(2)),
      }
      return brief
    },

    savePending() {
      return this.selectionAllotmentCounter > 0 || this.selectionPricingCounter > 0
    },
  },
  async beforeRouteLeave(to, from, next) {
    var response = true
    if (this.savePending) {
      response = await this.showContinueWithoutSaving()
    }

    next(response)
  },
  methods: {
    async aplicarFiltro() {
      var response = false
      if (this.savePending) {
        response = await this.showContinueWithoutSaving()
      }

      if (!this.savePending || (this.savePending && response)) {
        this.isReady = []
        this.clearPricingSelection()
        this.clearSelection()
        this.loadOccupancyFromApi(0)
        this.loadOccupancyFromApi(this.filters.offset)
        this.loadPricesAllotmentFromApi()
      }
    },
    updateOffset(offset) {
      this.filters.offset = offset
      this.loadOccupancyFromApi(offset)
    },
    changeTravelDate(range) {
      this.filters.travel_from = range.start
      this.filters.travel_to = range.end
    },
    initEvents(id) {
      this.isReady.push(id)
      if (this.isReady.length < 2) return
      // starts syncro scroll-X on all charts widgets
      setTimeout(() => {
        var charts = document.getElementsByClassName('x-sync')
        if (!!charts) {
          for (let index = 0; index < charts.length; index++) {
            let element = charts.item(index)
            if (element.getAttribute('id') === 'priceTable') {
              element = element.querySelector('div')
            }
            element.onscroll = function(event) {
              Array.from(charts).forEach((element) => {
                if (element.getAttribute('id') === 'priceTable') {
                  element = element.querySelector('div')
                }
                element.scrollLeft = event.target.scrollLeft
              })
            }
          }
        }
      }, 500)
    },
    changeVisibility(element, event) {
      switch (element) {
        case 'pricingHistoryCard':
          this.showPricingHistoryCard = !this.showPricingHistoryCard
          if (this.showPricingHistoryCard) {
            this.$nextTick(() => {
              this.$refs.stackedBars.updateData(this.stackedData)
            })
            event.target.innerHTML = "<i class='md-icon md-icon-font'>visibility_off</i>"
          } else {
            event.target.innerHTML = "<i class='md-icon md-icon-font'>visibility</i>"
          }
          break
        case 'occPickUpCard':
          this.showOccPickUpCard = !this.showOccPickUpCard
          if (this.showOccPickUpCard) {
            event.target.innerHTML = "<i class='md-icon md-icon-font'>visibility_off</i>"
          } else {
            event.target.innerHTML = "<i class='md-icon md-icon-font'>visibility</i>"
          }
          break
        case 'adrPickUpCard':
          this.showAdrPickUpCard = !this.showAdrPickUpCard
          if (this.showAdrPickUpCard) {
            event.target.innerHTML = "<i class='md-icon md-icon-font'>visibility_off</i>"
          } else {
            event.target.innerHTML = "<i class='md-icon md-icon-font'>visibility</i>"
          }
          break
        case 'pricingInformationCard':
          this.showPricingInformationCard = !this.showPricingInformationCard
          if (this.showPricingInformationCard) {
            this.$nextTick(() => {
              this.$refs.linesChart.updateData(this.linechartData())
            })
            event.target.innerHTML = "<i class='md-icon md-icon-font'>visibility_off</i>"
          } else {
            event.target.innerHTML = "<i class='md-icon md-icon-font'>visibility</i>"
          }
          break
        case 'fusionTable':
          this.showFusionTable = !this.showFusionTable
          if (this.showFusionTable) {
            event.target.innerHTML = "<i class='md-icon md-icon-font'>visibility_off</i>"
          } else {
            event.target.innerHTML = "<i class='md-icon md-icon-font'>visibility</i>"
          }
          break
      }
    },

    async refreshTable() {
      var response = false
      if (this.savePending) {
        response = await this.showContinueWithoutSaving()
      }

      if (!this.savePending || (this.savePending && response)) {
        this.clearPricingSelection()
        this.clearSelection()
        this.loadPricesAllotmentFromApi()
      }
    },
    loadPricesAllotmentFromApi() {
      this.searchPricingAllotment = true
      pricingApi.getPricingPricesAndAllotment(
        this.$root.hotelId,
        Object.assign(this.filters, {
          travel_from: this.formattedFrom,
          travel_to: this.formattedTo,
          room_type_ids: this.filters.room_type_ids,
          channel_online_types: this.filters.channel_online_types,
        }),
        (error, data) => {
          this.apiPriceAllotmentResponse = data
          this.linechartData()
          if (this.$refs.linesChart) {
            this.$nextTick(() => {
              this.$refs.linesChart.updateData(this.linechartData())
            })
          }

          this.apiPriceAllotmentResponse.channels_table.pricing_price_channels_data_set_dto.forEach((r) => {
            r.data.forEach((c) => {
              c.value.price.originalAmount = c.value.price.amount
            })
          })
          this.apiPriceAllotmentResponse.data_table.pricing_price_table_data_set_dto.forEach((r) => {
            r.data.forEach((c) => {
              c.value.originalAmount = c.value.amount
            })
          })

          this.searchPricingAllotment = false
          initScrollBlock()
        }
      )
    },
    loadOccupancyFromApi(anticipationDays) {
      if (anticipationDays === 0) {
        this.apiOccupancyResponse = null
      }

      pricingApi.getPricingOccupancy(
        this.$root.hotelId,
        Object.assign(this.filters, {
          travel_from: this.formattedFrom,
          travel_to: this.formattedTo,
          anticipation_days: anticipationDays,
        }),
        (error, data) => {
          if (!error) {
            this.stackedOptions.min_value = data.min_value
            this.stackedOptions.max_value = data.max_value

            let response = this.apiOccupancyResponse
            if (response == null) {
              response = { data_chart_per_anticipation: [], adr_data_chart_per_anticipation: [] }
            }
            response.min_value = data.min_value
            response.max_value = data.max_value
            response.adr_data_chart_per_anticipation.push(data.adr_data_chart_per_anticipation[0])
            response.data_chart_per_anticipation.push(data.data_chart_per_anticipation[0])
            response.label = data.label
            this.apiOccupancyResponse = response
            if (response.adr_data_chart_per_anticipation.length > 1) {
              this.updateStackedData()
              if (this.$refs.stackedBars) {
                this.$refs.stackedBars.updateData(this.stackedData)
              }
            }
          }
        }
      )
    },

    async fusionSave() {
      const isValid = await this.$refs.validator.validate()
      if (isValid) {
        if (this.selectionPricingCounter > 0) {
          this.saveRecommendedValues()
        }
        if (this.selectionAllotmentCounter > 0) {
          this.saveSimpleAllotments()
        }
      } else {
        this.$notify({
          timeout: 2500,
          message: '<strong>Not saved</strong>. Please check your inputs',
          icon: 'check_box',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: 'danger',
        })
      }
    },
    saveSimpleAllotments() {
      var data = {}
      try {
        var rawData = JSON.parse(JSON.stringify(this.apiPriceAllotmentResponse.channels_table.pricing_price_channels_data_set_dto))
        data = {
          channels_online: this.filters.channels_online,
          channel_ids: this.filters.channel_ids,
          rate_ids: this.filters.rate_ids,
          actions: rawData.reduce((prev, row) => {
            return prev.concat(
              row.data
                .filter((c) => c.value.allotment.is_selected)
                .map((c) => {
                  return SimpleAllotmentActionDTO.constructFromObject(
                    Object.assign(c.value.allotment, {
                      room_type_id: row.room_type_id,
                      travel_date: c.key,
                      // null if no action was clicked, true if close action was clicked
                      close: this.futureClass === null ? null : this.futureClass === 'future-close',
                      mlos: c.value.allotment.mlos_editable ? c.value.allotment.mlos[0].key : null,
                      allotment: c.value.allotment.current_allotment,
                    })
                  )
                })
            )
          }, []),
        }
        this.apiPriceAllotmentResponse.channels_table.pricing_price_channels_data_set_dto.forEach((d) => {
          d.data.filter((da) => da.value.allotment.is_selected).forEach((da) => this.$set(da.value.allotment, 'saved', true))
        })
      } catch (e) {
        console.log(e)
      }

      if (data.actions.length) {
        allotmentApi.simpleAllotmentAction(this.$root.hotelId, SimpleAllotmentDTO.constructFromObject(data))
        this.$notify({
          timeout: 4500,
          message: 'New allotments will be saved shortly',
          icon: 'check_box',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: 'info',
        })
        this.clearSelection()
        this.futureClass = null
      } else {
        this.$notify({
          timeout: 5000,
          message: 'Nothing saved. Please select some action',
          icon: 'info',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: 'info',
        })
      }
    },
    async validateMinumunMaximunPrice() {
      let response = true

      let underMinPrice = this.apiPriceAllotmentResponse.channels_table.pricing_price_channels_data_set_dto.some((d) => {
        if (d.editable) {
          if (d.value_format === 'RELATIVE') {
            return d.data.some((da) => {
              return (
                da.value.price.is_selected &&
                !!da.value.price.amount &&
                parseFloat(da.value.price.current) + parseFloat(da.value.price.amount) < parseFloat(da.value.price.minimum_price)
              )
            })
          } else if (d.value_format === 'PERCENTAGE') {
            return d.data.some((da) => {
              return (
                da.value.price.is_selected &&
                !!da.value.price.amount &&
                parseFloat(da.value.price.current) * (1 + parseFloat(da.value.price.amount) / 100) <
                  parseFloat(da.value.price.minimum_price)
              )
            })
          } else {
            return d.data.some((da) => {
              return (
                da.value.price.is_selected &&
                !!da.value.price.amount &&
                parseFloat(da.value.price.amount) < parseFloat(da.value.price.minimum_price)
              )
            })
          }
        }
      })
      let overMaxPrice = this.apiPriceAllotmentResponse.channels_table.pricing_price_channels_data_set_dto.some((d) => {
        if (d.editable) {
          if (d.value_format === 'RELATIVE') {
            return d.data.some((da) => {
              return (
                da.value.price.is_selected &&
                !!da.value.price.amount &&
                parseFloat(da.value.price.current) + parseFloat(da.value.price.amount) > parseFloat(da.value.price.maximum_price)
              )
            })
          } else if (d.value_format === 'PERCENTAGE') {
            return d.data.some((da) => {
              return (
                da.value.price.is_selected &&
                !!da.value.price.amount &&
                parseFloat(da.value.price.current) * (1 + parseFloat(da.value.price.amount) / 100) >
                  parseFloat(da.value.price.maximum_price)
              )
            })
          } else {
            return d.data.some((da) => {
              return (
                da.value.price.is_selected &&
                !!da.value.price.amount &&
                parseFloat(da.value.price.amount) > parseFloat(da.value.price.maximum_price)
              )
            })
          }
        }
      })

      if (overMaxPrice || underMinPrice) {
        response = await this.showContinueMinimunMaximunPrice()
      }

      return response
    },
    async saveRecommendedValues() {
      if (await this.validateMinumunMaximunPrice()) {
        pricingApi.savePricingPrices(this.$root.hotelId, this.getSavePriceRequest())
        this.$notify({
          timeout: 4500,
          message: 'New prices will be saved shortly',
          icon: 'check_box',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: 'info',
        })
        this.apiPriceAllotmentResponse.data_table.pricing_price_table_data_set_dto.forEach((d) => {
          d.data.filter((da) => da.value.is_selected).forEach((da) => this.$set(da, 'saved', true))
        })
        this.apiPriceAllotmentResponse.channels_table.pricing_price_channels_data_set_dto.forEach((d) => {
          d.data.filter((da) => da.value.price.is_selected).forEach((da) => this.$set(da.value.price, 'saved', true))
        })

        this.clearPricingSelection()
      }
    },
    getSavePriceRequest() {
      //se recupera los datos del componente pricing-table-row
      var dto = {
        original_request: Object.assign(this.filters, {
          travel_from: this.formattedFrom,
          travel_to: this.formattedTo,
        }),
        data_table: {
          // eslint-disable-next-line
          pricing_price_table_data_set_dto: JSON.parse(
            JSON.stringify(this.apiPriceAllotmentResponse.data_table.pricing_price_table_data_set_dto)
          ) //se filtran de data table las filas que son editables
            .filter((d) => d.editable)
            .map((d) => {
              //de las filas que son editables se seleccionan los datos que son seleccionados
              d.data = d.data.filter((da) => da.value.is_selected)
              return d
            }),
        },
        channels_table: {
          // eslint-disable-next-line
          pricing_price_channels_data_set_dto: JSON.parse(
            JSON.stringify(this.apiPriceAllotmentResponse.channels_table.pricing_price_channels_data_set_dto)
          ) //se filtran de channel table las filas que son editables (todos los room type)
            .filter((d) => d.editable)
            .map((d) => {
              //de las filas que son editables se seleccionan los datos que son seleccionados
              d.data = d.data.filter((da) => da.value.price.is_selected)
              return d
            }),
        },
      }
      return SavePriceRequestDTO.constructFromObject(dto)
    },

    saveAdvanceAllotment(data) {
      if (data.range_dates == null) {
        data.channel_ids = this.filters.channel_ids
        data.channels_online = this.filters.channels_online
        data.rate_ids = this.filters.rate_ids
      }
      var parsedData = AdvancedAllotmentActionRequestDTO.constructFromObject(data)
      if (!data.allotment_action.enabled) parsedData.allotment_action = null
      // eslint-disable-next-line
      if (!data.open_close_action_dto.enabled) parsedData.open_close_action_dto = null
      if (!data.mlos_action_dto.enabled) parsedData.mlos_action_dto = null
      allotmentApi.advancedAllotmentAction(this.$root.hotelId, parsedData, () => {
        setTimeout(() => {
          this.refreshTable()
        }, 3000)
      })
      this.$notify({
        timeout: 4500,
        message: 'New allotments will be saved shortly',
        icon: 'check_box',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'info',
      })
    },
    async saveAdvancePricing(data) {
      if (data.range_dates == null) {
        data.room_type_ids = this.filters.room_type_ids
        data.channel_ids = this.filters.channel_ids
        data.channels_online = this.filters.channels_online
        data.rate_ids = this.filters.rate_ids
      }
      var parsedData = AdvancedPricingActionRequestDTO.constructFromObject(data)
      // eslint-disable-next-line
      pricingApi.advancedPricingAction(this.$root.hotelId, parsedData, () => {
        setTimeout(() => {
          this.refreshTable()
        }, 3000)
      })
      this.$notify({
        timeout: 4500,
        message: 'New prices will be saved shortly',
        icon: 'check_box',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'info',
      })
    },
    allotmentSelected(isSelected, travelDate, roomTypeId) {
      this.futureClass = null
      if (isSelected) {
        // eslint-disable-next-line
        if (this.$refs['modal'].addRoomTypeDate(roomTypeId, travelDate)) {
          this.selectionAllotmentCounter++
        }
      } else {
        // eslint-disable-next-line
        if (this.$refs['modal'].removeRoomTypeDate(roomTypeId, travelDate)) {
          this.selectionAllotmentCounter--
        }
      }
    },
    pricingSelected(isSelected, travelDate, roomTypeId) {
      this.futureClass = null
      if (isSelected) {
        // eslint-disable-next-line
        if (this.$refs['modalPricing'].addRoomTypeDate(roomTypeId, travelDate)) {
          this.selectionPricingCounter++
        }
      } else {
        // eslint-disable-next-line
        if (this.$refs['modalPricing'].removeRoomTypeDate(roomTypeId, travelDate)) {
          this.selectionPricingCounter--
        }
      }
    },
    clearSelection() {
      this.apiPriceAllotmentResponse.channels_table.pricing_price_channels_data_set_dto.forEach((r) => {
        r.data.map((c) => {
          if (c.value.allotment?.['is_selected'] === true) {
            this.$set(c.value.allotment, 'is_selected', false)
          }
        })
      })
      this.$refs['modal'].clearRoomTypeDate()
      this.selectionAllotmentCounter = 0
    },
    clearPricingSelection() {
      this.apiPriceAllotmentResponse.data_table.pricing_price_table_data_set_dto.forEach((r) => {
        r.data.map((c) => {
          if (c.value['is_selected'] === true) {
            this.$set(c.value, 'is_selected', false)
          }
        })
      })

      this.apiPriceAllotmentResponse.channels_table.pricing_price_channels_data_set_dto.forEach((r) => {
        r.data.map((c) => {
          if (c.value.price['is_selected'] === true) {
            this.$set(c.value.price, 'is_selected', false)
          }
        })
      })
      this.$refs['modalPricing'].clearRoomTypeDate()
      this.selectionPricingCounter = 0
    },
    updateStackedData() {
      var getBarValues = function(data) {
        var bars = Array(this.apiOccupancyResponse.label.length)
        data.value.data.forEach((d) => {
          var label = this.apiOccupancyResponse.label.find((l) => l.key == d.key)
          // eslint-disable-next-line
          bars[label.value.toLowerCase()] = {
            value: d.value,
            order: label.key,
          }
        })
        return Object.assign({}, bars)
      }
      var getDataChartAnticipation = function(n) {
        var data = this.apiOccupancyResponse.data_chart_per_anticipation
          .find((d) => d.key == n)
          .value.dataset.map((d) => {
            return {
              label: this.moment(d.key).format('DD MMM'),
              data_offset: n,
              target: {
                value: d.value.target,
              },
              bars: getBarValues.call(this, d),
            }
          })
        return data
      }
      var data = {
        labels: getDataChartAnticipation.call(this, 0).map((d) => d.label),
        datasets: [].concat(getDataChartAnticipation.call(this, 0), getDataChartAnticipation.call(this, this.filters.offset)),
        options: this.apiOccupancyResponse.label.reduce((accum, current) => {
          accum[current.value.toLowerCase()] = {
            label: current.value,
            order: current.key,
          }
          return accum
        }, {}),
      }
      this.stackedData = data
      return true
    },

    linechartData() {
      this.linearData = {
        labels: this.apiPriceAllotmentResponse.data_chart.pricing_price_chart_data_set_dto[0].data.map((d) =>
          this.moment(d.key).format('DD MMM')
        ),
        datasets: this.apiPriceAllotmentResponse.data_chart.pricing_price_chart_data_set_dto.map((chart) => {
          return Object.assign(this.lineStyles[chart.label.toLowerCase()] || {}, {
            data: chart.data.map((d) => d.value),
            label: chart.label,
          })
        }),
      }

      return this.linearData
    },

    setFutureLock: function(event) {
      this.futureClass = 'future-close'
    },
    setFutureUnlock: function(event) {
      this.futureClass = 'future-open'
    },

    openAdvancedAllotment() {
      this.$refs['modal']
        .setChannelIds(this.filters.channel_ids)
        .setDateInterval(this.filters.travel_from, this.filters.travel_to)
        .open()
    },
    openAdvancedPricing() {
      this.$refs['modalPricing']
        .setChannelIds(this.filters.channel_ids)
        .setDateInterval(this.filters.travel_from, this.filters.travel_to)
        .open()
    },
    isWeekend: function(d) {
      let dayOfWeek = this.moment(d).format('E')
      return dayOfWeek == 6 || dayOfWeek == 7
    },
    showContinueWithoutSaving() {
      return this.showConfirmation('You have selected items, do you want to continue without saving?')
    },
    showContinueMinimunMaximunPrice() {
      return this.showConfirmation(
        'There are price changes that violate the minimum or maximum configured price, the price is changed to the corresponding minimum or maximum, do you want to continue with the changes?'
      )
    },
    showConfirmation(message) {
      return Swal.fire({
        title: 'Are you sure?',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, continue',
        cancelButtonText: 'Cancell',
        customClass: {
          cancelButton: 'md-button md-danger',
          confirmButton: 'md-button md-success',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          return true
        } else {
          return false
        }
      })
    },
  },
  created() {
    const from = this.$route.query.from ? this.moment(this.$route.query.from) : null
    if (from && from.isValid()) this.filters.travel_from = from.toDate().toString()
    const to = this.$route.query.to ? this.moment(this.$route.query.to) : null
    if (to && to.isValid()) this.filters.travel_to = to.toDate().toString()
    else
      this.filters.travel_to = this.moment()
        .add(this.maxDays, 'days')
        .toDate()
        .toISOString()
    let api = new RatesApi()
    api.getRates(this.$root.hotelId, (error, data) => {
      if (data.filter((t) => t['id'] == 'BAR').length > 0) {
        this.filters.rate_ids = ['BAR']
      }
      //this.loadFromApi()
    })
    this.currency = Currency[sessionStorage.getItem('currency')]
  },
  mounted() {
    const from = this.$route.query.from ? this.moment(this.$route.query.from) : null
    if (from && from.isValid()) this.filters.travel_from = from.toDate().toString()
    const to = this.$route.query.to ? this.moment(this.$route.query.to) : null
    if (to && to.isValid()) {
      this.filters.travel_to = to.toDate().toString()
    } else {
      this.filters.travel_to = this.moment()
        .add(this.maxDays, 'days')
        .toDate()
        .toISOString()
    }
    // check of wait until room type default are ready
    var getRoomTypeDefaults = function(vm) {
      return new Promise((resolve) => {
        ;(function waitForTypes() {
          var types = vm.$refs['roomTypeSelect'].getTypes()
          if (Array.isArray(types)) return resolve(types)
          setTimeout(waitForTypes, 200)
        })()
      })
    }
    getRoomTypeDefaults(this).then((roomTypesDefault) => {
      this.filters.room_type_ids = roomTypesDefault.map((t) => t.id)
      this.loadOccupancyFromApi(0)
      this.loadOccupancyFromApi(this.filters.offset)
      this.loadPricesAllotmentFromApi()
      //this.loadPricesFromApi()
      //this.loadFromApi()
    })
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/md/_variables.scss';
.opacity-0 {
  opacity: 0 !important;
}
.md-table-cell {
  min-width: 120px;
  max-width: 120px;
}
.md-table {
  table {
    width: 100%;
  }
}
.filtersContainer {
  position: sticky;
  z-index: 9;
  padding: 0 15px;
  top: 80px;
  .md-toolbar {
    border: none;
    -webkit-box-shadow: 0px 11px 9px -8px rgb(31 30 30 / 20%);
    box-shadow: 0px 11px 9px -8px rgb(31 30 30 / 20%);
    border-radius: 8px;
    background-color: #fff !important;
    padding: 15px 20px;
  }
}
.pricing {
  .visibility-button-container {
    display: flex;
    justify-content: end;
    margin-top: 15px;
    .visibility-button {
      outline: none;
      background: none;
      border: none;
      padding: 0;
      margin: 0;
      i {
        font-size: 15px;
        color: #98a2b3;
      }
    }
  }

  .md-layout {
    width: auto;
    display: inline-flex;
  }
  .md-card-content {
    overflow-x: auto;
    canvas {
      padding: 0 20px 0 140px;
    }
  }
  .occ {
    canvas {
      padding-left: 85px;
    }
    .md-table small {
      white-space: nowrap;
      display: block;
      min-width: 56px;
    }
  }
  .price {
    .priceTable {
      max-height: calc(100vh - 200px);
    }
    canvas {
      padding-left: 130px;
    }
    .md-table small {
      white-space: nowrap;
      display: block;
      min-width: 57px;
    }
  }
  .md-table-cell.h6 {
    width: 120px !important;
    .md-table-cell-container {
      max-width: 100%;
      min-width: 100px !important;
      width: 100px !important;
      overflow: hidden !important;
      //white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .md-select-menu {
    z-index: 1500 !important;
  }
}
.allotment {
  .allotment-content .md-table-content {
    position: relative;
    overflow: auto;
  }
  .allotment-table {
    max-height: calc(100vh - 200px);
    table {
      position: relative;
      border-collapse: collapse;
      overflow: unset;
    }
    tr th:first-child {
      left: 0;
      z-index: 3;
    }
    tr th {
      position: -webkit-sticky; /* for Safari */
      position: sticky;
      top: -1px;
      z-index: 2;
      background-color: #ffffff;
    }
    tr td.fixed-cell {
      position: -webkit-sticky !important; /* for Safari */
      position: sticky !important;
      left: 0;
      z-index: 2;
      background-color: #ffffff;
    }
  }
  .md-table-head-label,
  .md-table-head-container {
    padding: 0;
    height: auto;
  }
  .md-table-row {
    display: table-row-group;
  }
  td {
    min-height: 1px;
  }
  .md-table-cell {
    padding: 1px;
    min-height: 1px;
  }
  .md-table-head-label {
    font-weight: 400;
  }
  .md-table-cell:not(.h6) {
    & .md-table-cell-container {
      display: table;
      height: 100px;
      width: 100%;
    }
    height: 100%;
    min-width: 157px !important;
    max-width: 157px !important;
  }
  .md-table-head-container {
    text-align: center;
  }
  .is-non-dirty {
    &.future-open .future-selected {
      background: rgb(76, 175, 80);
    }
    &.future-close .future-selected {
      background: #f44336;
    }
  }
  .weekend {
    background-color: #e8e8e8 !important;
  }
  .md-table-row:hover .md-table-cell:not(.weekend) {
    background-color: #ffffff !important;
  }
}
.content {
  padding-bottom: 0px !important;
}
.right {
  float: right;
}
.card-header {
  padding-bottom: 15px;
}
.arrow-button,
.arrow-button:hover,
.arrow-button.md-button .md-ripple {
  background: $brand-primary !important;
}
.arrow-button:hover {
  opacity: 0.95;
}
.d-flex {
  display: flex;
}
@media only screen and (max-width: 560px) {
  //Filtro pricing
  .md-filters-container {
    display: flex;
    flex-flow: row-reverse !important;
    flex-wrap: wrap !important;
  }
  .md-filters-container i {
    margin: 0;
  }
  .md-filters-container span {
    width: 91%;
    margin-bottom: 6px;
  }
  .md-filters-container span .md-list {
    padding-left: 0 !important;
  }
  .md-filters-container span .md-field {
    margin-left: 0 !important;
  }
  //Filtros allotment
  .md-toolbar-section-start {
    flex-wrap: wrap;
  }
}
@media only screen and (max-width: 1710px) {
  .mainFilters {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(225px, 1fr));
    width: 100%;
    gap: 8px;
  }
}
</style>
